import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftComplaintsProps } from './props';
import { SarlaftComplaints } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftComplaints = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftComplaintsProps) => {
    const onSubmit = (data: SarlaftComplaints) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('dateComplaint', data?.dateComplaint || '');
        formik?.setFieldValue('bouquet', data?.bouquet || '');
        formik?.setFieldValue('company', data?.company || '');
        formik?.setFieldValue('value', data?.value || '');
        formik?.setFieldValue('complaint', data?.complaint || '');
        formik?.setFieldValue('compensation', data?.compensation || '');
    }, [data]);

    return {
        formik,
    };
};
